import React from "react";
import Cross from './pics/svg/cross.svg';
import Plus from './pics/plus.png'
import "./favourites.css";

function Favourites(){

    let root = document.documentElement

    function closeFavourites() {
        document.querySelector('.fixed .close').style.pointerEvents = "none"
        document.querySelector('.favourites-wrapper').style.transform = "scale(0.8)"
        document.querySelector('.favourites-wrapper').style.opacity = 0
        document.querySelector('.favourites-wrapper').style.pointerEvents = "none"
        hideDropdown();
    }
    function hideDropdown() {
        document.querySelector('.nav-bar').classList.add('hideNav')
        document.querySelectorAll('.nav-bar button:not(.dropdown)').forEach(button => {
            button.classList.remove('slideIn')
        })
        document.querySelector('.nav-bar').style.pointerEvents = "none"
        root.style.setProperty('--nav-blur', 'blur(0px)')
        root.style.setProperty('--dropdown-rotate', 'rotate(90deg)')
    }

    function goToSignIn() {
        closeFavourites()
        document.querySelector('.login-wrapper').style.transform = "scale(1)"
        document.querySelector('.login-wrapper').style.opacity = 1
        document.querySelector('.login-wrapper').style.pointerEvents = "all"
        document.querySelector('button.Login').style.pointerEvents = "all"
    }

    return (
        <div className="favourites-wrapper">
            <div className="favourites-container">
                <div className="favourites">
                    <div className="fixed">
                        <div className="favourites-heading">Your List</div>
                        <img onClick={closeFavourites} className="close" src={Cross} alt="X" />
                    </div>
                    <span className="signinmsg">
                        <img onClick={goToSignIn} src={Plus} alt="add"/>
                        <span><span onClick={goToSignIn}>Sign in</span>&nbsp;to add to your list</span>
                    </span>
                    <div className="favs-container">

                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default Favourites;
